import React from 'react';

import { BodyLoading } from './Body.loading';
import { BodyImageStyles, BodyStyles, BodyTextStyles } from './Body.styles';
import type { FacebookGroupPostComponentsProps } from './types';

export const Body: React.FC<FacebookGroupPostComponentsProps> = (props) => {
	const { size, message, previewImageUrl, loading, retryState } = props;

	if (loading) return <BodyLoading loading={loading} size={size} retryState={retryState} />;

	return (
		<div className={BodyStyles({ size })}>
			<span className={BodyTextStyles({ size })}>{message}</span>
			<img className={BodyImageStyles({ size })} src={previewImageUrl} aria-hidden alt="" data-testid="body-image" />
		</div>
	);
};
